import Client from "../AxiosClient";
const resource = "/private/dbFinance";
const publicApi = "/public/dbFinance";
const fileQTApi =
  "https://csdltaichinh.thainguyen.gov.vn:8066/api/ShareDataQuyetToan/file";
const fileTSApi =
  "https://csdltaichinh.thainguyen.gov.vn:8066/api/ShareDataTaiSan/file";

export default {
  //#region settlement
  async searchSettlement(year, report) {
    try {
      const result = await Client.get(
        `${resource}/get_qt?year=${year}&report=${report}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  //#endregion

  //#region asset
  async searchAsset(year, report) {
    try {
      const result = await Client.get(
        `${resource}/get_ts?year=${year}&report=${report}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },
  //#endregion

  async getFileQT(filter) {
    const accessToken = await this.getToken();
    const headers = {
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + accessToken,
        Accept: "application/octet-stream",
      },
    };
    const response = await Client.post(`${fileQTApi}`, filter, headers);
    const blob = new Blob([response.data], {
      type: "application/octet-stream",
    });
    const url = URL.createObjectURL(blob);

    // Tạo một liên kết để tải xuống tệp
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      filter.reportCode + "_" + filter.namBC + ".xls"
    ); // Thay 'ten_file_tai_ve.ext' bằng tên bạn muốn đặt cho tệp
    document.body.appendChild(link);
    link.click();
    // Xóa liên kết sau khi đã tải xuống
    document.body.removeChild(link);
  },

  async getFileTS(filter) {
    const accessToken = await this.getToken();
    const headers = {
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + accessToken,
        Accept: "application/octet-stream",
      },
    };
    const response = await Client.post(`${fileTSApi}`, filter, headers);
    // console.log(response);
    // return;
    const blob = new Blob([response.data], {
      type: "application/octet-stream",
    });
    const url = URL.createObjectURL(blob);

    // Tạo một liên kết để tải xuống tệp
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      filter.reportCode + "_" + filter.nam + ".xls"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  async getToken() {
    const result = await Client.get(`${publicApi}/gettoken`, {});

    return result.data.token;
  },

  async getqt() {
    const result = await Client.get(`${publicApi}/getlist_qt`, {});
    // console.log(result);
    return result.data.data;
  },
  async getts() {
    const result = await Client.get(`${publicApi}/getlist_ts`, {});

    return result.data.data;
  },

  async PUB_searchSettlement(year, report) {
    try {
      const result = await Client.get(
        `${publicApi}/get_qt?year=${year}&report=${report}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  //#endregion

  //#region asset
  async PUB_searchAsset(year, report) {
    try {
      const result = await Client.get(
        `${publicApi}/get_ts?year=${year}&report=${report}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },
  ///////// get nam
  async getYear(p) {
    const result = await Client.get(`${publicApi}/getYear?report=${p}`, {});
    //console.log(result.data.data[0].value);
    return result.data.data[0].value;
  },

  async getDashboard(p, y) {
    const result = await Client.get(
      `${publicApi}/getDashboard?report=${p}&year=${y}`,
      {}
    );
    //console.log(result.data.data[0].value);
    return result.data;
  },
};
